module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAACZM////yH5BAAHAP8ALAAAAAAMAAwAAAIVhI+pGx38QFNzmWqnoxGf6n2bRZYFADs="